import { render, staticRenderFns } from "./myUserInfo.vue?vue&type=template&id=8123a20c&scoped=true&"
import script from "./myUserInfo.vue?vue&type=script&lang=js&"
export * from "./myUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./myUserInfo.vue?vue&type=style&index=0&id=8123a20c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8123a20c",
  null
  
)

export default component.exports